/*!
   angular-inform v0.0.18
   (c) 2014 (null) McNull https://github.com/McNull/angular-inform
   License: MIT
*/
(function(angular) {
